import PropTypes from '../../_util/vue-types'

export const ITouchProps = {
  disabled: PropTypes.bool,
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.any,
  // onTouchStart: PropTypes.func,
  // onTouchEnd: PropTypes.func,
  // onTouchCancel: PropTypes.func,
  // onMouseDown: PropTypes.func,
  // onMouseUp: PropTypes.func,
  // onMouseLeave: PropTypes.func,
}



// WEBPACK FOOTER //
// ./components/vc-m-feedback/src/PropTypes.jsx